import {Component, inject, signal} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LoadingComponent} from '../../general/loading/loading.component';
import {ReactiveFormsModule,} from '@angular/forms';
import {CheckBadgeIconComponent} from '@core/svg-icons/check-badge-icon.component';
import {RouterLink} from '@angular/router';
import {UserService} from '@core/services/user.service';
import {HsFormsService} from '@core/services/hs-forms.service';
import {StoreConfigService} from '@core/services/store-config.service';

@Component({
  selector: 'app-subscribe-to-newsletters-modal',
  templateUrl: './subscribe-to-newsletters-modal.component.html',
  styleUrls: ['./subscribe-to-newsletters-modal.component.scss'],
  imports: [ModalContainerComponent, LoadingComponent, ReactiveFormsModule, CheckBadgeIconComponent, RouterLink]
})
export class SubscribeToNewslettersModalComponent {
  private modalService = inject(NgbModal);
  private userService = inject(UserService);
  private hsFormsService = inject(HsFormsService);
  private storeConfigService = inject(StoreConfigService);

  email: string;
  uuid: string;
  isCustomerCreateFlow = signal(false);

  loading = signal(false);
  currencyCode = this.storeConfigService.currencyCode;

  submit(subscribeToNewsletters: boolean) {
    if (subscribeToNewsletters) {
      this.submitHubSpotSubscription(this.uuid);
    }
    if (this.isCustomerCreateFlow()) {
      const message = subscribeToNewsletters ? $localize`Tak for din tilmelding` : $localize`Konto oprettet`;
      this.modalService.dismissAll();
      this.userService.confirmAccountModal(this.email, message);
    }
  }

  submitHubSpotSubscription(uuid: string) {
    const data = {
      uuid: uuid,
    }
    this.loading.set(true)
    this.hsFormsService.submitHubspotFormEvent('SubscribeToNewsletters', JSON.stringify(data)).then(() => {
    }).finally(() => {
      this.loading.set(false)
    }).catch(reason => {
      throw reason;
    });
  }
}
